module.exports = __webpack_public_path__ + "img/运动装备-5.5ef48a79.png";